import React, { Component } from 'react';
import ProjectList from '../projects/ProjectList';
import AnnouncementList from '../announcements/AnnouncementList';
import {Secondary} from '../../Theme';

import Card from 'material-ui/Card';
import logo from '../../assets/Vip_logo.png';
import title from '../../assets/vip_title_0.jpg';

const style = {
  hr: {
    borderTop: "3px double #8c8b8b"
  },
  card: {
    paddingBottom: "10px",
    margin: "10px",
  },
  cardHeader: {
    textAlign : 'left',
    color: "#8C1D40",
    clear:'left'
  },
  font:{
    color:"#212121",
    clear:'left'
  },
  image:{
    float:'center',
    height:'70px',
  }
}
class Home extends Component {
  render() {
    return(
      <div>
        <Card style={style.card} zDepth = {0}>
            {/* <img src = {logo} style = {style.image}/> */}
        <br />
            <img src={title} align="middle"/>
        <h1 style={style.cardHeader}>What is VIP?</h1>
          <p style = {style.font}>VIP at ASU capitalizes on the interests of undergraduates to engage in ongoing scientific research. Beginning as freshmen or sophomores, teams collaborate with upperclassmen and graduate students to address real problems guided by faculty scientists. Students earn academic or honors credits over 4 years.</p>
          <p style = {style.font}>VIP experience:
            <ul>
            <li style = {style.font}>Prepares students for the workplace or more advanced study</li>
            <li style = {style.font}>Facilitates in-depth experience and applied learning through multidisciplinary challenges</li>
            <li style = {style.font}>Enables broad understanding of the innovation process, and</li>
            <li style = {style.font}>Allows for mastery of critical thinking skills and exposure to a variety of skills and roles.</li>
          </ul>
          </p>
          <p style = {style.font}>To inquire about or join VIP areas listed below, follow links for teams below actively recruiting now! </p>
        </Card>
        <h1 style = {{textAlign:'left', color:Secondary}}>Announcements</h1>
        <AnnouncementList pageLength = {2} />
        <hr style={style.hr}/>
        <h1 style = {{textAlign:'left', color:Secondary}}>Active Projects</h1>
        <ProjectList />
        <hr/>
          <p>VIP @ ASU is partially supported by a grant from the Helmsley Charitable Trust, through a subcontract from Georgia Tech, founder and host of the VIP Consortium. VIP @ ASU is hosted in the PRIME Center, directed by <a href="https://isearch.asu.edu/profile/1120179"><font color={Secondary}>Carole E. Greenes, Ed.D.,</font></a> and co-directed by <a href="https://isearch.asu.edu/profile/1114610"> <font color={Secondary}> Robert A. Greenes, M.D., Ph.D.</font></a>  The center works closely with the Provost, Barrett Honors College, and academic units  to facilitate approval of student academic program and honors credits. It works closely with VIP faculty to foster optimal projects and experiences with VIP programs and themes pursued by the universities of the VIP Consortium.</p>
          <p>ASU is a new member of the 20-University VIP Consortium (see <a href="http://www.vip.gatech.edu/vip-consortium"><font color={Secondary}>http://www.vip.gatech.edu/vip-consortium)</font></a> dedicated to advancing undergraduate learning through real-world research.</p>
      </div>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/component/home/Home.js